(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fan9s-premium-aplus"] && !Shopify.designMode) return;
  try {
    
    class Fan9sPremiumAplus extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.statusEl = this.querySelector('[data-fan9s-compare-status]');
        this.carousels = Array.from(this.querySelectorAll('[data-fan9s-carousel]'))
          .map((carousel) => this.setupCarousel(carousel))
          .filter(Boolean);

        this.querySelectorAll('[data-fan9s-add-to-cart]').forEach((button) => {
          button.addEventListener('click', () => this.addCompareProduct(button));
        });

        this.initialized = true;
      }

      setupCarousel(carousel) {
        const viewport = carousel.querySelector('[data-fan9s-carousel-viewport]');
        const slides = Array.from(carousel.querySelectorAll('[data-fan9s-carousel-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-fan9s-carousel-dot]'));
        const prevButton = carousel.querySelector('[data-fan9s-carousel-prev]');
        const nextButton = carousel.querySelector('[data-fan9s-carousel-next]');

        if (!viewport || !slides.length) return null;

        const state = { viewport, slides, dots, currentSlide: 0, scrollTimer: null };

        prevButton?.addEventListener('click', () => this.goToSlide(state, state.currentSlide - 1));
        nextButton?.addEventListener('click', () => this.goToSlide(state, state.currentSlide + 1));
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(state, index));
        });
        viewport.addEventListener('scroll', () => {
          window.clearTimeout(state.scrollTimer);
          state.scrollTimer = window.setTimeout(() => this.syncSlideFromScroll(state), 80);
        });
        viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToSlide(state, state.currentSlide - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToSlide(state, state.currentSlide + 1);
          }
        });

        this.updateCarouselState(state, 0);
        return state;
      }

      goToSlide(state, index) {
        if (!state?.viewport || !state.slides.length) return;

        const count = state.slides.length;
        const nextIndex = (index + count) % count;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        state.viewport.scrollTo({
          left: state.viewport.clientWidth * nextIndex,
          behavior
        });
        this.updateCarouselState(state, nextIndex);
      }

      syncSlideFromScroll(state) {
        if (!state?.viewport || !state.slides.length) return;

        const width = state.viewport.clientWidth || 1;
        const index = Math.round(state.viewport.scrollLeft / width);
        this.updateCarouselState(state, index);
      }

      updateCarouselState(state, index) {
        const count = state.slides.length;
        if (!count) return;

        state.currentSlide = Math.max(0, Math.min(index, count - 1));
        state.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === state.currentSlide ? 'false' : 'true');
        });
        state.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === state.currentSlide ? 'true' : 'false');
        });
      }

      async addCompareProduct(button) {
        const variantId = button?.dataset?.variantId;
        if (!variantId || button.disabled) return;

        const originalText = button.textContent;
        button.classList.add('is-loading');
        button.disabled = true;
        button.textContent = '追加中...';
        this.setCompareStatus('');

        try {
          const sectionsToUpdate = ['page-header', 'cart-drawer']
            .map((selector) => document.querySelector(selector))
            .filter((element) => element && typeof element.updateFromCartChange === 'function');
          const sectionIds = sectionsToUpdate.map((element) => element.dataset.sectionId).filter(Boolean);
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          formData.append('sections_url', window.location.pathname);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          const response = await fetch(window.theme?.routes?.cartAdd || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const item = await response.json();
          if (!response.ok) {
            const message = typeof item.description === 'string' ? item.description : item.message;
            throw new Error(message || 'カートに追加できませんでした。');
          }

          if (item.sections && sectionsToUpdate.length) {
            sectionsToUpdate.forEach((element) => {
              const html = item.sections[element.dataset.sectionId];
              if (html) element.updateFromCartChange(html);
            });
          } else {
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          }

          const cartDrawer = document.querySelector('.js-cart-drawer');
          if (window.theme?.settings?.afterAddToCart === 'page' && window.theme?.routes?.cart) {
            window.setTimeout(() => {
              window.location.href = window.theme.routes.cart;
            }, 300);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(button);
          } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
              bubbles: true,
              detail: { opener: button }
            }));
          }

          button.textContent = button.dataset.successText || '追加しました';
          this.setCompareStatus(`${item.product_title || '商品'}をカートに追加しました。`);
          document.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: { variantId: item.variant_id }
          }));
        } catch (error) {
          button.textContent = originalText;
          this.setCompareStatus(error.message || 'カートに追加できませんでした。', true);
        } finally {
          window.setTimeout(() => {
            button.classList.remove('is-loading');
            button.disabled = false;
            if (button.textContent !== originalText) button.textContent = originalText;
          }, 1600);
        }
      }

      setCompareStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
      }
    }

    if (!customElements.get('fan9s-premium-aplus')) {
      customElements.define('fan9s-premium-aplus', Fan9sPremiumAplus);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-showcase-slider"] && !Shopify.designMode) return;
  try {
    
  class FeatureShowcaseSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.carousel = this.querySelector('carousel-slider');
      this.slider = this.querySelector('.slider');
      this.slides = Array.from(this.querySelectorAll('.feature-showcase__slide'));
      this.prevButton = this.querySelector('button[name="prev"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.activeIndex = 0;

      if (!this.slider || this.slides.length === 0) return;

      this.handleSelect = this.handleSelect.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.addEventListener('on:carousel-slider:select', this.handleSelect);
      this.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => this.scrollToIndex(index));
      });
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollToIndex(Math.max(this.activeIndex - 1, 0)));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollToIndex(Math.min(this.activeIndex + 1, this.slides.length - 1)));
      }

      requestAnimationFrame(() => {
        this.scrollToIndex(0, false);
      });
      this.initialized = true;
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('on:carousel-slider:select', this.handleSelect);
    }

    handleSelect(event) {
      this.setActiveSlide(event.detail.index);
    }

    handleBlockSelect(event) {
      const slide = event.target.closest('.feature-showcase__slide');
      if (!slide || !this.contains(slide)) return;
      const index = Number(slide.dataset.index);
      this.setActiveSlide(index);
      window.setTimeout(() => {
        this.scrollToIndex(index);
      }, 240);
    }

    scrollToIndex(index, smooth = true) {
      const target = this.slides[index];
      if (!target) return;

      const shouldCenter = window.matchMedia('(min-width: 768px)').matches;
      const desktopFocusPoint = Math.min(this.slider.clientWidth * 0.38, 360);
      const mobileInset = 10;
      const offset = shouldCenter
        ? target.offsetLeft - (desktopFocusPoint - (target.clientWidth / 2))
        : target.offsetLeft - mobileInset;
      this.slider.scrollTo({
        left: offset,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.setActiveSlide(index);
    }

    setActiveSlide(index) {
      this.activeIndex = index;
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
    }
  }

  if (!customElements.get('feature-showcase-slider')) {
    customElements.define('feature-showcase-slider', FeatureShowcaseSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro1-mini-aplus-carousel"] && !Shopify.designMode) return;
  try {
    
  class Pro1MiniAplusCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.rowState = [];
      this.rows = Array.from(this.querySelectorAll('[data-aplus-row]'));
      this.rows.forEach((row) => this.setupRow(row));
      this.setupCompareCart();
      this.initialized = true;
    }

    disconnectedCallback() {
      this.rowState?.forEach((state) => {
        state.track?.removeEventListener('scroll', state.onScroll);
      });
    }

    setupRow(row) {
      const track = row.querySelector('[data-aplus-track]');
      const slides = Array.from(row.querySelectorAll('[data-aplus-slide]'));
      const previousButton = row.querySelector('[data-aplus-prev]');
      const nextButton = row.querySelector('[data-aplus-next]');
      const dots = Array.from(row.querySelectorAll('[data-aplus-dot]'));
      const state = { activeIndex: 0, row, track, slides, previousButton, nextButton, dots, scrollTimer: null };

      if (!track || slides.length === 0) return;

      state.onScroll = () => {
        window.clearTimeout(state.scrollTimer);
        state.scrollTimer = window.setTimeout(() => {
          const trackLeft = track.scrollLeft;
          const slideWidth = slides[0]?.clientWidth || 1;
          const index = Math.round(trackLeft / slideWidth);
          this.updateRow(state, Math.max(0, Math.min(index, slides.length - 1)));
        }, 80);
      };

      track.addEventListener('scroll', state.onScroll, { passive: true });
      previousButton?.addEventListener('click', () => this.scrollToSlide(state, state.activeIndex - 1));
      nextButton?.addEventListener('click', () => this.scrollToSlide(state, state.activeIndex + 1));
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => this.scrollToSlide(state, dotIndex));
      });

      this.rowState.push(state);
      this.updateRow(state, 0);
    }

    scrollToSlide(state, index) {
      const targetIndex = Math.max(0, Math.min(index, state.slides.length - 1));
      const target = state.slides[targetIndex];
      if (!target) return;

      state.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      this.updateRow(state, targetIndex);
    }

    updateRow(state, index) {
      state.activeIndex = index;

      state.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.setAttribute('aria-hidden', String(slideIndex !== index));
      });

      if (state.previousButton) state.previousButton.disabled = index === 0;
      if (state.nextButton) state.nextButton.disabled = index === state.slides.length - 1;
      state.dots?.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }

    setupCompareCart() {
      this.statusEl = this.querySelector('[data-compare-status]');
      this.querySelectorAll('[data-compare-add-to-cart]').forEach((button) => {
        button.addEventListener('click', () => this.addCompareProduct(button));
      });
    }

    async addCompareProduct(button) {
      const variantId = button?.dataset?.variantId;
      if (!variantId || button.disabled) return;

      const originalText = button.textContent;
      button.classList.add('is-loading');
      button.disabled = true;
      button.textContent = '追加中...';
      this.setCompareStatus('');

      try {
        const sectionsToUpdate = ['page-header', 'cart-drawer']
          .map((selector) => document.querySelector(selector))
          .filter((element) => element && typeof element.updateFromCartChange === 'function');
        const sectionIds = sectionsToUpdate.map((element) => element.dataset.sectionId).filter(Boolean);
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections_url', window.location.pathname);
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));

        const response = await fetch(window.theme?.routes?.cartAdd || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const item = await response.json();
        if (!response.ok) {
          const message = typeof item.description === 'string' ? item.description : item.message;
          throw new Error(message || 'カートに追加できませんでした。');
        }

        if (item.sections && sectionsToUpdate.length) {
          sectionsToUpdate.forEach((element) => {
            const html = item.sections[element.dataset.sectionId];
            if (html) element.updateFromCartChange(html);
          });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        const cartDrawer = document.querySelector('.js-cart-drawer');
        if (window.theme?.settings?.afterAddToCart === 'page' && window.theme?.routes?.cart) {
          window.setTimeout(() => {
            window.location.href = window.theme.routes.cart;
          }, 300);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(button);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            bubbles: true,
            detail: { opener: button }
          }));
        }

        button.textContent = button.dataset.successText || '追加しました';
        this.setCompareStatus(`${item.product_title || '商品'}をカートに追加しました。`);
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: item.variant_id }
        }));
      } catch (error) {
        button.textContent = originalText;
        this.setCompareStatus(error.message || 'カートに追加できませんでした。', true);
      } finally {
        window.setTimeout(() => {
          button.classList.remove('is-loading');
          button.disabled = false;
          if (button.textContent !== originalText) button.textContent = originalText;
        }, 1600);
      }
    }

    setCompareStatus(message, isError = false) {
      if (!this.statusEl) return;
      this.statusEl.textContent = message;
      this.statusEl.classList.toggle('is-error', isError);
    }
  }

  if (!customElements.get('pro1-mini-aplus-carousel')) {
    customElements.define('pro1-mini-aplus-carousel', Pro1MiniAplusCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
